@let doc = state.document();
@let loaded = state.isLoaded();

<!-- Toolbar -->
@if (showToolbar) {
  <div class="pdf-toolbar" aria-label="PDF viewer toolbar">
    <div class="pdf-toolbar__group">
      @if (showBack) {
        <button type="button" class="pdf-tool" (click)="onBack()" ngbTooltip="Back" aria-label="Back">
          <app-icon name="arrowLeft" [size]="18" />
        </button>
      }
      @if (showSidebar) {
        <button
          type="button"
          class="pdf-tool"
          [class.pdf-tool--active]="state.sidebarOpen()"
          (click)="toggleSidebar()"
          [attr.aria-pressed]="state.sidebarOpen()"
          ngbTooltip="Toggle pages panel"
          aria-label="Toggle pages panel"
        >
          <app-icon name="list" [size]="18" />
        </button>
      }
      <span class="pdf-toolbar__file" [ngbTooltip]="doc?.fileName || fileName || ''">
        <app-icon name="file" [size]="16" />
        <span class="pdf-toolbar__file-name">{{ doc?.fileName || fileName || 'Document' }}</span>
      </span>
    </div>

    <div class="pdf-toolbar__group pdf-toolbar__group--center">
      <button
        type="button"
        class="pdf-tool"
        (click)="previousPage()"
        [disabled]="!state.canGoPrevious()"
        ngbTooltip="Previous page"
        aria-label="Previous page"
      >
        <app-icon name="chevronUp" [size]="18" />
      </button>
      <span class="pdf-pager">
        <input
          class="pdf-pager__input"
          type="number"
          inputmode="numeric"
          [value]="pageInput()"
          (change)="onPageInputCommit($any($event.target).value)"
          (keyup.enter)="onPageInputCommit($any($event.target).value)"
          [attr.min]="1"
          [attr.max]="state.pageCount()"
          aria-label="Current page"
        />
        <span class="pdf-pager__total">/ {{ state.pageCount() }}</span>
      </span>
      <button
        type="button"
        class="pdf-tool"
        (click)="nextPage()"
        [disabled]="!state.canGoNext()"
        ngbTooltip="Next page"
        aria-label="Next page"
      >
        <app-icon name="chevronDown" [size]="18" />
      </button>
    </div>

    <div class="pdf-toolbar__group pdf-toolbar__group--end">
      @if (showZoom) {
        <button
          type="button"
          class="pdf-tool"
          (click)="zoomOut()"
          ngbTooltip="Zoom out"
          aria-label="Zoom out"
        >
          <app-icon name="zoomOut" [size]="18" />
        </button>
        <span class="pdf-toolbar__zoom" aria-live="polite">{{ state.zoom() }}%</span>
        <button
          type="button"
          class="pdf-tool"
          (click)="zoomIn()"
          ngbTooltip="Zoom in"
          aria-label="Zoom in"
        >
          <app-icon name="zoomIn" [size]="18" />
        </button>
        <button
          type="button"
          class="pdf-tool"
          [class.pdf-tool--active]="state.fitMode() === 'width'"
          (click)="setFit('width')"
          ngbTooltip="Fit width"
          aria-label="Fit width"
        >
          <app-icon name="fitWidth" [size]="18" />
        </button>
        <button
          type="button"
          class="pdf-tool"
          [class.pdf-tool--active]="state.fitMode() === 'page'"
          (click)="setFit('page')"
          ngbTooltip="Fit page"
          aria-label="Fit page"
        >
          <app-icon name="fitPage" [size]="18" />
        </button>
      }
      @if (showRotate) {
        <span class="pdf-toolbar__divider"></span>
        <button
          type="button"
          class="pdf-tool"
          (click)="rotate('left')"
          ngbTooltip="Rotate left"
          aria-label="Rotate left"
        >
          <app-icon name="rotateLeft" [size]="18" />
        </button>
        <button
          type="button"
          class="pdf-tool"
          (click)="rotate('right')"
          ngbTooltip="Rotate right"
          aria-label="Rotate right"
        >
          <app-icon name="rotateRight" [size]="18" />
        </button>
      }
      <span class="pdf-toolbar__divider"></span>
      @if (showSearch) {
        <button
          type="button"
          class="pdf-tool"
          [class.pdf-tool--active]="state.searchOpen()"
          (click)="toggleSearch()"
          [attr.aria-pressed]="state.searchOpen()"
          ngbTooltip="Search"
          aria-label="Search document"
        >
          <app-icon name="search" [size]="18" />
        </button>
      }
      @if (showDownload) {
        <button
          type="button"
          class="pdf-tool"
          (click)="onDownload()"
          ngbTooltip="Download"
          aria-label="Download"
        >
          <app-icon name="download" [size]="18" />
        </button>
      }
      @if (showPrint) {
        <button type="button" class="pdf-tool" (click)="onPrint()" ngbTooltip="Print" aria-label="Print">
          <app-icon name="print" [size]="18" />
        </button>
      }
      @if (showFullscreen) {
        <button
          type="button"
          class="pdf-tool"
          (click)="toggleFullscreen()"
          [ngbTooltip]="state.fullscreen() ? 'Exit fullscreen' : 'Fullscreen'"
          [attr.aria-label]="state.fullscreen() ? 'Exit fullscreen' : 'Enter fullscreen'"
        >
          <app-icon [name]="state.fullscreen() ? 'minimize' : 'maximize'" [size]="18" />
        </button>
      }
      @if (showTheme) {
        <button
          type="button"
          class="pdf-tool"
          (click)="toggleTheme()"
          [ngbTooltip]="state.theme() === 'dark' ? 'Light theme' : 'Dark theme'"
          aria-label="Toggle colour theme"
        >
          <app-icon [name]="state.theme() === 'dark' ? 'sun' : 'moon'" [size]="18" />
        </button>
      }
    </div>
  </div>
}

<!-- Search bar -->
@if (showSearch && state.searchOpen()) {
  <div class="pdf-search" role="search">
    <app-icon name="search" [size]="16" />
    <input
      #searchBox
      class="pdf-search__input"
      type="search"
      placeholder="Search document…"
      [value]="searchInput()"
      (input)="searchInput.set($any($event.target).value)"
      (keyup.enter)="runSearch(searchBox.value)"
      aria-label="Search text"
    />
    <span class="pdf-search__count">
      @if (state.totalMatches() > 0) {
        {{ state.activeMatchIndex() + 1 }} / {{ state.totalMatches() }}
      } @else if (state.searchSummary()) {
        No matches
      }
    </span>
    <button
      type="button"
      class="pdf-tool"
      (click)="runSearch(searchBox.value)"
      ngbTooltip="Find"
      aria-label="Find"
    >
      <app-icon name="search" [size]="16" />
    </button>
    <button
      type="button"
      class="pdf-tool"
      (click)="previousMatch()"
      [disabled]="state.totalMatches() === 0"
      ngbTooltip="Previous match"
      aria-label="Previous match"
    >
      <app-icon name="chevronUp" [size]="16" />
    </button>
    <button
      type="button"
      class="pdf-tool"
      (click)="nextMatch()"
      [disabled]="state.totalMatches() === 0"
      ngbTooltip="Next match"
      aria-label="Next match"
    >
      <app-icon name="chevronDown" [size]="16" />
    </button>
    <button
      type="button"
      class="pdf-tool"
      (click)="toggleSearch()"
      ngbTooltip="Close search"
      aria-label="Close search"
    >
      <app-icon name="x" [size]="16" />
    </button>
  </div>
}

<!-- Body -->
<div class="pdf-body">
  @if (showSidebar && state.sidebarOpen() && loaded) {
    <aside class="pdf-sidebar" aria-label="Pages">
      <div class="pdf-sidebar__list">
        @for (layout of pageLayouts(); track trackByPage($index, layout)) {
          <button
            type="button"
            class="pdf-sidebar__item"
            [class.pdf-sidebar__item--active]="layout.number === state.currentPage()"
            (click)="goToPage(layout.number)"
            [attr.aria-current]="layout.number === state.currentPage()"
          >
            <span
              class="pdf-sidebar__thumb"
              [style.aspect-ratio]="layout.width + ' / ' + layout.height"
            >
              <app-icon name="file" [size]="20" />
            </span>
            <span class="pdf-sidebar__num">{{ layout.number }}</span>
          </button>
        }
      </div>
    </aside>
  }

  <div
    #scroller
    class="pdf-scroller"
    [class.pdf-scroller--sidebar]="showSidebar && state.sidebarOpen()"
  >
    @if (loaded) {
      <div class="pdf-pages">
        @for (layout of pageLayouts(); track trackByPage($index, layout)) {
          <!-- NOSONAR Web:S6819 — kept role="img" on a <div>: it wraps the <canvas> PDF render target,
               and a native <img> cannot contain a canvas. The role + aria-label give the rendered page
               image semantics for assistive tech. -->
          <div
            #pageEl
            class="pdf-page"
            [attr.data-page]="layout.number"
            [style.width.px]="layout.width"
            [style.height.px]="layout.height"
            [attr.aria-label]="'Page ' + layout.number"
            role="img"
          >
            <canvas class="pdf-page__canvas"></canvas>
            @if (watermark) {
              <div class="pdf-watermark" aria-hidden="true">{{ watermark }}</div>
            }
          </div>
        }
      </div>
    }
  </div>
</div>

<!-- Loading overlay -->
@if (state.isLoading()) {
  <output class="pdf-overlay" aria-live="polite">
    @if (loadingTemplate) {
      <ng-container [ngTemplateOutlet]="loadingTemplate" />
    } @else {
      <app-spinner [config]="{ type: 'infinite-spinner', size: 'large' }" />
      <p class="pdf-overlay__text">
        Loading document
        @if (state.loadProgress() > 0) {
          · {{ state.loadProgress() * 100 | number: '1.0-0' }}%
        }
      </p>
    }
  </output>
}

<!-- Error overlay -->
@if (state.hasError()) {
  <div class="pdf-overlay pdf-overlay--error" role="alert">
    @if (errorTemplate) {
      <ng-container
        [ngTemplateOutlet]="errorTemplate"
        [ngTemplateOutletContext]="{ $implicit: state.error()!, retry: retry }"
      />
    } @else {
      <span class="pdf-overlay__icon"><app-icon name="alert" [size]="40" /></span>
      <p class="pdf-overlay__text">{{ state.error()?.message }}</p>
      <button type="button" class="pdf-retry" (click)="retry()">
        <app-icon name="refresh" [size]="16" /> Retry
      </button>
    }
  </div>
}
